import { Component, OnInit } from '@angular/core';
import { AchievementsService } from '../../services/achievements-services';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { AddAcheivementComponent } from '../add-acheivement/add-acheivement.component';
import { AchievementDetailsComponent } from '../achievement-details/achievement-details.component';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-get-acheivements',
  templateUrl: './get-acheivements.component.html',
  styleUrls: ['./get-acheivements.component.scss'],
})
export class GetAcheivementsComponent extends BaseComponent implements OnInit {

  form:FormGroup

  constructor(
    public service: AchievementsService,
    route: Router,
    private fb:FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService
  ) {
    super(route, service, null);
  }

  ngOnInit() {
    this.initForm();
    this.loadEntities();
  }
initForm(){
  this.form = this.fb.group({
    nameAR: ['']
  });
}


clearFilter(){
  this.form.controls['nameAR'].setValue('');
  this.loadEntitiesWithFilter('')
}

handleSearch(){

if (!this.form.value.nameAR.trim()) {
  this.toast.danger('برجاءاختيار الاسم لاتمام عملية البحث', 'رساله تحذيرية');
  return
}
  if((this.form.value.nameAR)){
    const name = this.form.value.nameAR.trim();
    this.form.controls['nameAR'].setValue(name);    
    this.loadEntitiesWithFilter(`nameAR:${name}`)
  }
}


  addNew() {
    this.diag
      .open(AddAcheivementComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

  delete(id) {
    this.service.delete(id).subscribe((res) => {
      this.loadEntities();
      this.toast.show('تم الحذف بنجاح', '', { status: 'success', duration: 3000 });
    });
  }

  detail(model) {
    this.diag.open(AchievementDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddAcheivementComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
